import Vue from 'vue';
import Router from 'vue-router';

import Index from './views/Index';
import Tsinghua from './views/Tsinghua';
import Login from './views/Index/Login';

import shell from './views/lessonplay_shell/shell/login';

import ican from './views/lessonplay_shell/ican/login';
import yuanxi from './views/lessonplay_shell/yuanxi/login';
import inner_training from './views/lessonplay_shell/inner_training/login';
import airport from './views/airport/airport/login';

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			component: Index,
			children: [
				{
					path: '/',
					name: 'login',
					meta: {
						title: '登录 - 课玩 lessonplan'
					},
					component: Login
				},
				{
					path: '/register',
					name: 'register',
					meta: {
						title: '注册 - 课玩 lessonplan'
					},
					component: () => import( /* webpackChunkName: "register" */ './views/Index/Register.vue')
				},
				{
					path: 'newWxUser',
					name: 'wxRegister',
					meta: {
						title: '微信注册 - 课玩 lessonplan'
					},
					component: () => import( /* webpackChunkName: "register" */ './views/Index/WxRegister.vue')
				},
				{
					path: '/forgot',
					name: 'forgot',
					meta: {
						title: '找回密码 - 课玩 lessonplan'
					},
					component: () => import( /* webpackChunkName: "forgot" */ './views/Index/Forgot.vue')
				},
			],
		},
		{
			path: '/tsinghua',
			component: Tsinghua,
			children: [
				{
					path: '',
					name: 'tsinghua-login',
					meta: {
						title: '学生登录 - 课玩 lessonplan'
					},
					component: () => import( /* webpackChunkName: "tsinghua-login" */ './views/Tsinghua/Login.vue')
				},
				{
					path: 'register',
					name: 'tsinghua-register',
					meta: {
						title: '学生注册 - 课玩 lessonplan'
					},
					component: () => import( /* webpackChunkName: "tsinghua-register" */ './views/Tsinghua/Register.vue')
				},
				{
					path: 'forgot',
					name: 'tsinghua-forgot',
					meta: {
						title: '找回密码 - 课玩 lessonplan'
					},
					component: () => import( /* webpackChunkName: "tsinghua-forgot" */ './views/Tsinghua/Forgot.vue')
				},
			],
		},
		//课玩壳
		{ path: '/shell/:type', component: shell },
		{ path: '/ican', component: ican },
		{ path: '/inner-training', component: inner_training },
		//元习
		{ path: '/yuanxi', component: yuanxi },
		{ path: '/airport', component: airport },
		{ path: '/zju', component: yuanxi },
		{ path: '/sciencep', component: yuanxi },
		{ path: '/csspw', component: yuanxi },
		{ path: '/xjtupress', component: yuanxi },
		{ path: '/hnfnu', component: yuanxi },
		{ path: '/nwu', component: yuanxi },
		{ path: '/uestcp', component: yuanxi },
		{ path: '/xnjdcbs', component: yuanxi },
		{ path: '/bsu', component: yuanxi },
		{ path: '/hust', component: yuanxi },
	]
})

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next()
})

export default router